import { useState } from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import styles from "./BuyPop.module.scss";

// img
import p1 from "../../../assets/images/current.png";
import diamond from "../../../assets/images/diamond.png";
import { useDispatch, useSelector } from "react-redux";
import {
  buyEnergy, getCustomPurchaseLink, checkPaymentStatus,
  updateProfile, cancelPayment, getUserProfile
} from "../../../lib/store/actions";
import { showToast } from "../../../helper/common";
import useEightHourCountdown from "../../../hooks/useEightHrTimer";
// import useUserBalance from "../../../hooks/useUserBalance";
import { useGameContext } from "../../../context/GameContext";
import styled from "styled-components";
import { useTonConnectUI } from '@tonconnect/ui-react';
import VerifyingPaymentLoader from "../../Loader/verifyPayment";
import CustomLoader from "../../Loader/index";
import tokenIcn from "../../../assets/images/usdt-ton.png";
import { getUsdtWalletAddress, getNetworkName, usePreventTonModalClose } from '../../../helper/common';
const GAS_FEE = '50000000';

const BuyPop = ({ buy, setBuy, onFinish }) => {

  usePreventTonModalClose();
  const { gameEnergyLeft, playSound } = useGameContext();
  const [qty, setQty] = useState(1);
  const { settings } = useSelector(({ Settings }) => Settings);
  const { butEnergyLoading } = useSelector(({ Game }) => Game);
  const { hours, minutes, seconds } = useEightHourCountdown();
  const { btncBalance } = useGameContext();
  const [tonConnectUI] = useTonConnectUI();
  const [loading, setLoading] = useState(false);
  const [verify, setVerify] = useState(false);
  const [selectedCurrency, setSelectedCurrency] = useState('btnc');
  const dispatch = useDispatch();

  const { settingsData, userData } =
    useSelector(({ Settings, Auth }) => ({
      userData: Auth.user,
      settingsData: Settings.settings
    }));

  const handleQty = (value) => {
    if (!settings?.energy?.maxEnergyBalance) return;
    if (value === "min") {
      if (qty > 1) {
        setQty((prev) => prev - 1);
      }
      else {
        setQty(1);
      }
    }
    else if (value === "add") {
      if ((parseInt(qty) + 1) * settings?.energy?.chargeFor1Energy >= btncBalance) {
        return;
      }
      if ((gameEnergyLeft + qty) > settings?.energy?.maxEnergyBalance) return;
      setQty((prev) => prev + 1);
    }
  };

  const purchaseEnergy = async (energyCount, currency) => {
    if (currency === "btnc") {
      if (settings?.energy?.chargeFor1Energy * qty > btncBalance) {
        showToast("Insufficient balance!", "error");
        return;
      }
      let bodyParm = {
        quantity: energyCount,
      };
      dispatch(
        buyEnergy({
          data: bodyParm,
          callBack: (err, res) => {
            if (err) return;
            playSound("energybuy");
            setBuy(!buy);
            onFinish(res?.data);
          },
        })
      );
    }
    else if (currency === "usdt") {
      if (settingsData?.energy?.maxEnergyBalance < (userData.energyBalance + energyCount)) {
        showToast('Purchase not allowed—exceeds max energy limit.', 'info');
        return;
      }
      if (tonConnectUI && !tonConnectUI?.connected) {
        await tonConnectUI.connectWallet();
        if (tonConnectUI?.account) {
          const networkName = getNetworkName(tonConnectUI?.account?.chain);
          const targetNetwork = settingsData?.payment?.tonNetwork;
          if (networkName !== targetNetwork) {
            showToast(`Please switch your wallet network manually to ${targetNetwork} and reconnect!`, "error");
            return;
          }
        }
        setLoading(true);
        dispatch(
          updateProfile({
            data: { _id: userData?._id, walletAddress: tonConnectUI?.account?.address },
            callBack: (err, data) => {
              if (err) {
                setLoading(false);
                showToast("Network Error! Please try later.", "error");
                return;
              }
              dispatch(getCustomPurchaseLink({
                data: {
                  quantity: 1,
                  energy: energyCount
                },
                callBack: async (err, res) => {
                  if (err) {
                    setLoading(false);
                    showToast("Network Error! Please try later.", "error");
                    return;
                  }
                  setLoading(!loading);
                  const { purchaseID, payload } = res.data;
                  if (tonConnectUI?.connected) {
                    const userTonAddress = tonConnectUI?.account?.address;
                    const userUSDTAddress = await getUsdtWalletAddress(userTonAddress, settingsData);
                    if (userUSDTAddress) {
                      try {
                        let result = await tonConnectUI.sendTransaction({
                          validUntil: Math.floor(Date.now() / 1000) + 300,
                          // network: settingsData?.payment?.tonNetwork,
                          messages: [
                            {
                              address: userUSDTAddress || userTonAddress,
                              amount: GAS_FEE,
                              payload: payload
                            }
                          ]
                        });
                        console.log("result ===>", result);
                        setLoading(false);
                        setVerify(true);
                        await verifyPayment(purchaseID);
                      }
                      catch (error) {
                        console.info("Transaction was rejected or cancelled by the user", error);
                        setLoading(false);
                        setVerify(false);
                        showToast("Transaction was cancelled!", "error");
                      }
                    }
                    else {
                      showToast("USDT Wallet not found!", "error");
                      setLoading(false);
                      setVerify(false);
                      handledHide();
                    }
                  }
                }
              }));
            },
          })
        )
      }
      else if (tonConnectUI?.connected) {
        if (tonConnectUI?.account) {
          const networkName = getNetworkName(tonConnectUI?.account?.chain);
          const targetNetwork = settingsData?.payment?.tonNetwork;
          if (networkName !== targetNetwork) {
            showToast(`Please switch your wallet network manually to ${targetNetwork}`, "error");
            return;
          }
        }
        setLoading(!loading);
        dispatch(getCustomPurchaseLink({
          data: {
            quantity: 1,
            energy: energyCount
          },
          callBack: async (err, res) => {
            if (err) {
              setLoading(false);
              return;
            }
            setLoading(!loading);
            const { purchaseID, payload } = res.data;
            if (tonConnectUI?.connected) {
              const userTonAddress = tonConnectUI?.account?.address;
              const userUSDTAddress = await getUsdtWalletAddress(userTonAddress, settingsData);
              try {
                let result = await tonConnectUI.sendTransaction({
                  validUntil: Math.floor(Date.now() / 1000) + 300,
                  // network: settingsData?.payment?.tonNetwork,
                  messages: [
                    {
                      address: userUSDTAddress || userTonAddress,
                      amount: GAS_FEE,
                      payload: payload
                    }
                  ]
                });
                console.log("result ===>", result);
                setLoading(false);
                setVerify(true);
                await verifyPayment(purchaseID);
              }
              catch (error) {
                console.info("Transaction was rejected or cancelled by the user", error);
                setLoading(false);
                setVerify(false);
                showToast("Transaction was cancelled!", "error");
                dispatch(cancelPayment({
                  data: {
                    purchaseID: purchaseID
                  },
                  callBack: async (err, res) => {
                    if (err) {
                    }
                  }
                }));
              }
            }
            else {
              if (tonConnectUI && !tonConnectUI?.connected) {
                tonConnectUI.connectWallet();
              }
            }
          }
        }));
      }
      else {
        showToast('Please connect telegram wallet!', "error");
        setLoading(false);
      }
    }
  };

  const verifyPayment = async (purchaseID) => {
    try {
      const checkPayment = async (attempts = 0) => {
        if (attempts > 20) {
          throw new Error('Timeout waiting for payment');
        }
        if (!purchaseID) {
          throw new Error('No purchase ID provided');
        }
        try {
          const res = await dispatch(checkPaymentStatus({ data: { purchaseID } })).unwrap();
          if (res?.status === "success") {
            setVerify(false);
            showToast('Energy Purchased Successfully!', 'success');
            handledHide();
            dispatch(
              getUserProfile({
                data: {
                  _id: userData?._id,
                },
                callBack: (err, res) => {
                  if (err) return;
                },
              })
            );
            return;
          }
          else {
            await new Promise(resolve => setTimeout(resolve, 5000));
            return await checkPayment(attempts + 1);
          }
        }
        catch (err) {
          console.error("Error checking payment:", err);
          setLoading(false);
          setVerify(false);
          handledHide();
          showToast('Package Payment timeout!', 'error');
        }
      };
      await checkPayment();
    }
    catch (error) {
      console.error('Verification error:', error);
      setLoading(false);
      setVerify(false);
      handledHide();
      showToast('Package Payment timeout!', 'error');
    }
    finally {
      setLoading(false);
    }
  };

  const handledHide = () => {
    setBuy(!buy);
  };

  return (
    <>
      {verify && (<VerifyingPaymentLoader />)}
      {loading && <CustomLoader />}
      <Modal
        show={buy}
        onHide={handledHide}
        backdrop="true"
        centered
        scrollable="true"
        className={`${styles.buyPop} bottomPop`}
        keyboard={false}
      >
        <div className="modalWrpper">

          <Modal.Body>
            <Button
              onClick={handledHide}
              variant="transparent"
              className="border-0 p-0 position-absolute"
              style={{ top: 15, right: 15 }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="26"
                height="26"
                viewBox="0 0 26 26"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M13.0024 26.0048C20.1834 26.0048 26.0048 20.1834 26.0048 13.0024C26.0048 5.82137 20.1834 0 13.0024 0C5.82137 0 0 5.82137 0 13.0024C0 20.1834 5.82137 26.0048 13.0024 26.0048ZM13.0062 14.1485L18.1747 19.3251L19.3205 18.1711L14.152 13.0026L19.3205 7.83412L18.1747 6.68827L13.0062 11.8568L7.83767 6.68015L6.6837 7.83412L11.8603 13.0026L6.6837 18.1711L7.83767 19.3251L13.0062 14.1485Z"
                  fill="#506380"
                />
              </svg>
            </Button>
            <div className="top pb-3 text-center">
              <h5
                className="m-0 text-white d-inline-block pb-1 fw-bold"
                style={{ borderBottom: "0.2px solid #07ECF9" }}
              >
                ENERGY
              </h5>
            </div>
            <div className="py-2">
              <div className="flex flex-column gap-10 mx-auto"
                style={{ maxWidth: 290 }}
              >
                <div
                  className={`${styles.box} shadow-sm position-relative mx-auto text-center rounded-4 p-3`}
                >
                  <div className="py-1">
                    <img src={p1} alt="" className="img-fluid" />
                  </div>
                  <div
                    className={`${styles.quantity} pt-2 pb-3 d-flex align-items-center justify-content-center gap-10`}
                  >
                    <Button
                      onClick={() => handleQty("min")}
                      className={`${qty > 1 && styles.active
                        } d-flex align-items-center justify-content-center commonBtn border-0`}
                      style={{ minWidth: "unset" }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="15"
                        height="3"
                        viewBox="0 0 15 3"
                        fill="none"
                      >
                        <rect width="15" height="3" rx="1.5" fill="white" />
                      </svg>
                    </Button>
                    <input
                      disabled={true}
                      type="text"
                      value={qty}
                      className={`${styles.formControl} form-control text-center fw-bold text-white`}
                    />
                    <Button
                      disabled={(gameEnergyLeft + qty) >= settings?.energy?.maxEnergyBalance ||
                        (parseInt(qty) + 1) * settings?.energy?.chargeFor1Energy >= btncBalance}
                      onClick={() => handleQty("add")}
                      className={`${((gameEnergyLeft + qty) >= settings?.energy?.maxEnergyBalance ||
                        (parseInt(qty) + 1) * settings?.energy?.chargeFor1Energy >= btncBalance) ? "" : styles.active
                        } d-flex align-items-center justify-content-center commonBtn border-0`}
                      style={{ minWidth: "unset" }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="17"
                        height="16"
                        viewBox="0 0 17 16"
                        fill="none"
                      >
                        <rect
                          y="6.31738"
                          width="16.1092"
                          height="3.15924"
                          rx="1.57962"
                          fill="white"
                        />
                        <rect
                          width="15.7938"
                          height="3.22185"
                          rx="1.61092"
                          transform="matrix(0.00512754 -0.999987 0.999988 0.0049302 6.44098 15.7939)"
                          fill="white"
                        />
                      </svg>
                    </Button>
                  </div>
                </div>
                <div className="">
                  <p className="m-0 pt-2 text-white text-start fw-light">
                    Choose Payment Method
                  </p>
                  <RadioSelect className="mt-2 d-flex align-items-center gap-10 justify-content-center">
                    <label
                      className=" w-100 position-relative "

                    >
                      <input
                        type="radio"
                        name="currency"
                        className="position-absolute h-100 w-100 "
                        value="btnc"
                        checked={selectedCurrency === "btnc"}
                        onClick={() => setSelectedCurrency("btnc")}
                        style={{
                          cursor: "pointer", left: 0,
                          top: 0,
                          zIndex: 999,
                          opacity: 0,
                        }}
                      />
                      <div className="d-flex align-items-center text-white cursor-pointer justify-content-center gap-10 p-1">
                        {/* <span>Buy with</span> */}
                        <span className="icn">
                          <img
                            src={diamond}
                            alt="Diamond"
                            className="img-fluid"
                            style={{ height: 30 }}
                          />
                        </span>
                        {settings?.energy?.chargeFor1Energy * qty}
                      </div>
                    </label>

                    {/* <span class="text-white"> OR </span> */}

                    <label
                      className=" w-100 position-relative "
                    >
                      <input
                        type="radio"
                        className="position-absolute h-100 w-100 "
                        name="currency"
                        value="usdt"
                        checked={selectedCurrency === "usdt"}
                        onClick={() => setSelectedCurrency("usdt")}
                        style={{
                          cursor: "pointer", left: 0,
                          top: 0,
                          zIndex: 999,
                          opacity: 0,
                        }}
                      />
                      <div className="d-flex align-items-center text-white cursor-pointer justify-content-center gap-10 p-1">
                        {/* <span>Buy with</span> */}
                        <span className="icn">
                          <img
                            src={tokenIcn}
                            alt="USDT"
                            className="img-fluid"
                            style={{ height: 30 }}
                          />
                        </span>
                        {(settings?.energy?.priceFor1Energy * qty)?.toFixed(2)}
                      </div>
                    </label>
                  </RadioSelect>
                </div>
              </div>
            </div>

            <p className="text-center mx-auto" style={{ color: "#EBF049", maxWidth: 290 }}>USDT must be sent via TON chain. A small amount of TON is required for fees</p>

            <div
              style={{ maxWidth: 290 }}

              className="mt-3 mx-auto text-center">
              <Button
                style={{
                  height: 48,
                  width: "100%"
                }}
                disabled={butEnergyLoading || !selectedCurrency}
                onClick={() => purchaseEnergy(qty, selectedCurrency)}
                className={`${styles.submitBtn} d-inline-flex align-items-center justify-content-center fw-bold commonBtn border-0`}
              >
                {butEnergyLoading ? <Spinner size="sm" /> : "BUY"}
              </Button>
            </div>
            <div className="py-2 mt-2" >
              <p className="m-0 text-center" style={{
                color: "#838282",
                fontWeight: 500,
                fontSize: 15
              }}><span className="mx-1">Auto Refill  </span><span className="themeClr d-inline-block" style={{ width: 80 }}>{hours}:{minutes}:{seconds}</span></p>
            </div>
          </Modal.Body>
        </div>
      </Modal>
    </>
  );
};

const RadioSelect = styled.div`
label {
  div {
    background: #13131B;
    border-radius: 10px;
    height: 60px;
    min-width: 137px;
    font-size: 14px;
    font-family: "Space Grotesk", sans-serif;
    font-weight: 300;
    border: 1px solid transparent
  }
}
  input:checked + div {
        opacity: 1;
        border-color: #242AFC
  }
`

export default BuyPop;
